import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserImagePasteDemo from 'src/games/demos/phaserImagePasteDemo/Main';

interface ImagePasteDemoProps extends PageProps<{}> {
}

class ImagePasteDemo extends React.Component<ImagePasteDemoProps> {
    constructor(props: ImagePasteDemoProps) {
        super(props);
        bindAllOfThis(this, ImagePasteDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserImagePasteDemo />
        </div>);
    }
}

export default ImagePasteDemo;



// WEBPACK FOOTER //
// ./src/pages/game/demos/ImagePasteDemo.tsx